import { permissionCheck } from "./permission-check";
import { buildYearTermQueryString } from "../../Layout/routing-service";

export const buildProgramAdmin = (navigation, strings, permissions,onClick) => {
  let baseUrl = navigation.region
    ? `/areas/${navigation.area.id}/regions/${navigation.region.id}`
    : `/areas/${navigation.area.id}/regions/na`;
  baseUrl = navigation.coordinator
    ? `${baseUrl}/coordinators/${navigation.coordinator.id}/programs/${navigation.program.id}`
    : `${baseUrl}/coordinators/na/programs/${navigation.program.id}`;

  const queryString = buildYearTermQueryString(navigation);

  const item = {
    id:13,
    type: "group",
    label: strings.programAdministration,
    "data-id": "accordion-program-admin-group",
    items: [],
  };
  const isInstitute = navigation.program.programType === "institute";
  const items = item.items;
  if (permissionCheck(navigation, "readProgram")) {
    items.push({
      id:14,
      type: "link",
      label: strings.generalInformation,
      "data-id": "accordion-program-admin-general-info",
      href: `${baseUrl}/info${queryString}`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/info${queryString}`,
        });
      }
    });
    items.push({
      id:15,
      type: "link",
      label: strings.faculty,
      "data-id": "accordion-program-admin-faculty",
      href: `${baseUrl}/faculty${queryString}`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/faculty${queryString}`,
        });
      }
    });
  }

  if (permissionCheck(navigation, "readBuilding")) {
    items.push({
      id:16,
      type: "link",
      label: strings.buildings,
      "data-id": "accordion-program-admin-building",
      href: `${baseUrl}/buildings${queryString}`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/buildings${queryString}`,
        });
      }
    });
  }
  if (
    permissionCheck(navigation, "readYearTerm") &&
    navigation.year &&
    navigation.year.id > 0
  ) {
    items.push({
      id:17,
      type: "link",
      label: strings.yearTerm,
      "data-id": "accordion-program-admin-year-term",
      href: `${baseUrl}/years/${navigation.year.id}/info`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/years/${navigation.year.id}/info`,
        });
      }
    });
  }
  if (!isInstitute && permissionCheck(navigation, "readPeriods")) {
    items.push({
      id:18,
      type: "link",
      label: strings.periods,
      "data-id": "accordion-program-admin-periods",
      href: `${baseUrl}/periods${queryString}`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/periods${queryString}`,
        });
      }
    });
  }
  return item;
};
